export const themeSelector = (state) => state.theme;

export const songSelector = (state) => state.song;
